import { forwardRef } from 'react';
import { Icon } from '@chakra-ui/react';
import { QIconProps } from './Icon';

export const AIAssessment = forwardRef<SVGSVGElement, Partial<QIconProps>>(
  (props, ref) => {
    return (
      <Icon viewBox="0 0 24 24" color="currentColor" {...props} ref={ref}>
        <svg>
          <path
            fill="currentColor"
            fillRule="evenodd"
            d="M13.43 19.084a8 8 0 0 0-.979-.436c-.601-.222-.601-1.074 0-1.296a8 8 0 0 0 .978-.436l.037-.019a8.3 8.3 0 0 0 3.431-3.431l.02-.037a8 8 0 0 0 .435-.978c.222-.601 1.074-.601 1.296 0a8 8 0 0 0 .436.978l.019.037a8.3 8.3 0 0 0 3.431 3.431l.037.02a8 8 0 0 0 .978.435c.601.222.601 1.074 0 1.296a8 8 0 0 0-.978.436l-.037.019a8.3 8.3 0 0 0-3.431 3.431l-.02.037a8 8 0 0 0-.435.978c-.222.601-1.074.601-1.296 0a8 8 0 0 0-.436-.978l-.019-.037a8.3 8.3 0 0 0-3.431-3.431zM15.485 18A10.3 10.3 0 0 1 18 20.515 10.3 10.3 0 0 1 20.515 18 10.3 10.3 0 0 1 18 15.486 10.3 10.3 0 0 1 15.486 18M7 9a1 1 0 0 1 1-1h2a1 1 0 1 1 0 2H8a1 1 0 0 1-1-1m0 4a1 1 0 0 1 1-1h5a1 1 0 1 1 0 2H8a1 1 0 0 1-1-1"
          />
          <path
            fill="currentColor"
            fillRule="evenodd"
            d="M6 1a3 3 0 0 0-3 3v16a3 3 0 0 0 3 3h4c.333 0 1-.2 1-1s-.667-1-1-1H6a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h7v5a1 1 0 0 0 1 1h5v1c0 .333.2 1 1 1s1-.667 1-1V8a1 1 0 0 0-.293-.707l-6-6A1 1 0 0 0 14 1zm11.586 6L15 4.414V7z"
          />
          <path
            fill="currentColor"
            d="M7 17a1 1 0 0 1 1-1h1a1 1 0 1 1 0 2H8a1 1 0 0 1-1-1"
          />
        </svg>
      </Icon>
    );
  },
);

AIAssessment.displayName = 'AIAssessment';
